import React from 'react';
import { motion } from 'motion/react';

export const LoadingScreen: React.FC<{ overlay?: boolean }> = ({ overlay = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: overlay ? 1 : 0.985 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: overlay ? 1.012 : 1 }}
      transition={{ duration: overlay ? 0.42 : 0.28, ease: [0.22, 1, 0.36, 1] }}
      className={`${overlay ? 'fixed inset-0 z-[120]' : ''} flex min-h-screen min-h-[100svh] w-full items-center justify-center bg-[#030308] px-6`}
    >
      <div className="relative flex w-full max-w-sm flex-col items-center text-center">
        <div className="absolute inset-x-0 top-1/2 h-24 -translate-y-1/2 rounded-full bg-gradient-to-r from-pink-500/12 via-blue-500/10 to-cyan-400/12 blur-3xl" />
        <div className="absolute left-1/2 top-1/2 h-40 w-40 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/[0.02] blur-3xl" />
        <div className="relative z-10 overflow-hidden rounded-[30px] border border-white/8 bg-white/[0.03] px-8 py-10 shadow-[0_24px_70px_rgba(0,0,0,0.34)] backdrop-blur-md">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-[22px] border border-white/10 bg-white/[0.05] shadow-[0_10px_24px_rgba(0,0,0,0.18)]">
            <span className="bg-gradient-to-r from-white via-pink-100 to-blue-100 bg-clip-text text-2xl font-black tracking-[0.18em] text-transparent">
              SIX
            </span>
          </div>
          <h1 className="text-2xl font-black tracking-tight text-white">SixPass</h1>
          <p className="mt-3 text-sm font-medium text-slate-400">Preparando sua experiência...</p>
          <div className="mt-6 h-1.5 w-full overflow-hidden rounded-full bg-white/8">
            <motion.div
              className="h-full rounded-full bg-gradient-to-r from-pink-500 via-blue-500 to-cyan-400"
              animate={{ x: ['-100%', '100%'] }}
              transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
            />
          </div>
          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-pink-400/70" />
            <span className="h-1.5 w-1.5 rounded-full bg-blue-400/70" />
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-300/70" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};
